export const roundUpToNext10 = (num) => {
  const currNum = Math.floor(num / 10);
  const nextNum = currNum + 1;
  return Math.ceil(nextNum) * 10;
};
